<template>
  <div class="image_container">
    <NavBar title="云影像" @onClickLeft="onClickLeft"> </NavBar>
    <div class="img_box">
      <div class="viewportWrapper" :style="{ height: dicomHeight - 136 + 'px' }">
        <div class="viewport" ref="canvas" data-index="0" oncontextmenu="return false"></div>
        <div class="overlay">
          <div>Zoom:{{ patientInfo.zoom }}</div>
          <div class="numb_page">lm:{{ currentDicomIndex + 1 }} <span>/</span>{{ imageCount }}</div>
          <div>{{patientInfo.wwc}}</div>
        </div>
        <div class="img_button">
          <div class="img_button_text">
            <p>查看原始影像请点击</p>
            <img :src="down" alt="" />
          </div>
          <!--翻页 滑动条-->
          <div class="img_button_Slider" :class="{ loop_background: imageCount > 1 }">
            <LoopPlay
              ref="loopPlay"
              :imageCount="imageCount"
              :currentDicomIndex.sync="currentDicomIndex"
              @loadCurrnetDicom="loadCurrnetDicom"
            ></LoopPlay>
            <div class="img_button_png" @click="openDicom">
              <img src="../../../assets/照相机.png" alt="" />
              <p>DICOM</p>
            </div>
          </div>
        </div>
      </div>
      <div class="drag"></div>
      <div class="img_list_box">
        <ul class="img_list" :style="{ width: serialFirstList.length * 80 + 'px' }">
          <li
            @click="selectSerial(key)"
            v-for="(item, key) in serialFirstList"
            :key="key"
            :class="{ active: active == key }"
          >
            <div class="menu_imge">
              <div
                ref="dicom"
                v-bind:style="{ width: '80px', height: '80px' }"
                data-index="0"
                ondragstart="return false"
              ></div>
            </div>
            <div class="menu_text">
              <p>共{{ item.imageCount }}张</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <van-loading type="spinner" class="loading" v-show="loadingSohw" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar/index.vue'
import LoopPlay from '@/components/LoopPlay/index'
import { GetPatientReportImageInfos, AddCloudImageViewRecord } from '@/api/CloudFilmService'
import { ArrayGroup } from '@/utils/common'
import { GetFileServiceUrl, GetGoBackUrlParms } from '@/utils/cacheUtils'
import * as cornerstone from '../../../../public/static/cornerstone.js'
import * as cornerstoneWADOImageLoader from '../../../../public/static/cornerstoneWADOImageLoader.js'
import * as Hammer from '../../../../public/static/hammer.js'
import * as cornerstoneMath from '../../../../public/static/cornerstoneMath.js'
import * as cornerstoneTools from '../../../../public/static/cornerstoneTools.js'
import * as dicomParser from '../../../../public/static/dicomParser.min.js'
// import { converter } from '@/utils/encodeConverter'
import { isMobile } from '@/utils/common'
import { EncryptAES, DecryptAES } from '@/utils/stringUtils'

cornerstoneTools.external.Hammer = Hammer
cornerstoneTools.external.cornerstone = cornerstone
cornerstoneTools.external.cornerstoneMath = cornerstoneMath

cornerstoneTools.init({
  /**
   * When cornerstone elements are enabled,
   * should `mouse` input events be listened for?
   */
  mouseEnabled: true,
  /**
   * When cornerstone elements are enabled,
   * should `touch` input events be listened for?
   */
  touchEnabled: true,
  /**
   * A special flag that synchronizes newly enabled cornerstone elements. When
   * enabled, their active tools are set to reflect tools that have been
   * activated with `setToolActive`.
   */
  globalToolSyncEnabled: false,
  /**
   * Most tools have an associated canvas or SVG cursor. Enabling this flag
   * causes the cursor to be shown when the tool is active, bound to left
   * click, and the user is hovering the enabledElement.
   */
  showSVGCursors: false,
})

cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath
//指定要注册加载程序的基石实例
cornerstoneWADOImageLoader.external.cornerstone = cornerstone
cornerstoneWADOImageLoader.external.dicomParser = dicomParser
cornerstone.registerImageLoader('http', cornerstoneWADOImageLoader.loadImage)
cornerstone.registerImageLoader('https', cornerstoneWADOImageLoader.loadImage)

export default {
  name: 'ImageCover',
  components: {
    NavBar,
    LoopPlay,
  },
  data() {
    return {
      serialFirstList: [],
      down: require('../../../assets/线性向下图标.svg'),
      serialList: [],
      active: 0,
      patientInfo: {
        patientId: '',
        accessionNumber: '',
        number: '',
        hosptialName: '',
        zoom: '',
      },
      //当前dicom索引
      currentDicomIndex: 0,
      imageCount: 0,
      loadingSohw: true,
      timeoutBox: null,
      isLoopPlay: false,
      dicomHeight: 0,
    }
  },
  created() {
    document.body.style.overflow = 'hidden'
    this.dicomHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  },
  mounted() {
    //窗口变化
    window.onresize = () => {
      return (() => {
        //刷新页面
        location.reload()
        this.Reset()
      })()
    }
  },
  activated() {
    this.IsEncryption = DecryptAES(this.$route.query.isEncryption) === '1'
    this.getDicomData()
  },
  deactivated() {
    document.body.style.overflow = ''
    clearTimeout(this.timeoutBox) //初始化timeout定时器，防止定时器重叠
  },
  methods: {
    onClickLeft() {
      this.$router.push({ path: '/reportView?' + GetGoBackUrlParms() })
    },
    //获取服务器数据
    getDicomData() {
      this.loadingSohw = true
      GetPatientReportImageInfos({ patientreportID: this.$route.query.reportInfoID })
        .then(async (resp) => {
          if (resp && resp.Success && resp.Result) {
            let FilmFileList = resp.Result.find((c) => c.Category === 2)
            if (FilmFileList && FilmFileList.Images && FilmFileList.Images.length > 0) {
              AddCloudImageViewRecord({
                CloudImagePatientID: DecryptAES(this.$route.query.CloudImagePatientID),
                IDs: FilmFileList.ExaminationImageIDs,
              }).then()
            }

            let fimeImages = resp.Result.filter((c) => c.Category === 2).map((c) => c.Images)
            if (fimeImages && fimeImages.length > 0) {
              fimeImages = fimeImages[0]
              const fileServiceUrl = await GetFileServiceUrl()
              let NewSerialIndex = 0
              let OldSerialIndex = fimeImages[0].SerialIndex
              fimeImages.forEach((c) => {
                c.ImageRelaFileName = fileServiceUrl + c.ImageRelaFileName
                if (OldSerialIndex !== c.SerialIndex) {
                  OldSerialIndex = c.SerialIndex
                  NewSerialIndex = NewSerialIndex + 1
                }
                c.SerialIndex = NewSerialIndex
              })
              var imageGroup = ArrayGroup(fimeImages, 'SerialIndex')
              if (imageGroup) {
                this.serialList = []
                imageGroup.forEach((item) => {
                  this.serialList[item.key] = item.value
                })
                localStorage.setItem('serialList', EncryptAES(JSON.stringify(this.serialList)))
                //滑动翻页
                this.ScrollMouseWheel(this.serialList[0])
                //获取序列第一张图
                this.serialFirstList = []
                this.serialList.forEach((item, serialIndex) => {
                  this.serialFirstList.push({
                    key: serialIndex,
                    dicom: item[0],
                    imageCount: item.length,
                  })
                })
                this.$nextTick(() => {
                  this.getSerialList()
                })
              }
            } else {
              this.loadingSohw = false
              this.$notify({ type: 'warning', message: '没有查询到该检查的原始影像！' })
            }
          } else {
            this.loadingSohw = false
          }
        })
        .catch((err) => {
          this.loadingSohw = false
        })
    },
    // 进入功能页
    openDicom() {
      this.$refs.loopPlay.onLookPlay(1)
      this.$router.push({
        path: 'imageView',
        query: {
          sequenceKey: this.active,
        },
      })
    },
    //获取序列显示图像信息
    getSerialList() {
      var index = 0
      //生成图像
      this.serialFirstList.forEach((item) => {
        //生成图像
        // 找到要渲染的元素
        const canvas = this.$refs.dicom[index]
        // 在 DOM 中将 canvas 元素注册到 cornerstone
        cornerstone.enable(canvas)
        var dicom = item.dicom
        // let imageId = "wadouri:" + vue.prototype.appConfig.DicomUrl + dicom.ImagePath;
        let imageId = 'wadouri:' + dicom.ImageRelaFileName
        //  Load & Display
        cornerstone.loadAndCacheImage(imageId).then(
          function (image) {
            // 设置元素视口
            var viewport = cornerstone.getDefaultViewportForImage(canvas, image)
            // 显示图像
            cornerstone.displayImage(canvas, image, viewport)
          },
          function (err) {
            alert(err)
          }
        )

        index++
      })
      setTimeout(() => {
        this.loadingSohw = false
      }, 500)
    },
    //选择序列
    selectSerial(key) {
      this.$refs.loopPlay.onLookPlay(1)
      //重置滑动
      this.$refs.loopPlay.slideIndex = 1
      //设置序列索引
      // this.serialListIndex = key
      this.active = key
      this.currentDicomIndex = 0
      this.showSerialPannel = false
      //加载序列列表
      this.ScrollMouseWheel(this.serialList[key])
    },
    //鼠标滑动
    ScrollMouseWheel(series) {
      var canvasList = []
      let canvass = this.$refs.canvas
      canvasList.push(canvass)
      canvasList.forEach((canvas) => {
        // 在 DOM 中将 canvas 元素注册到 cornerstone
        cornerstone.enable(canvas)
        const scheme = 'wadouri'
        var list = []
        list = series
        const imageIds = list.map((seriesImage) => `${scheme}:${seriesImage.ImageRelaFileName}`)
        //获取当前序列
        this.currentserial = imageIds
        this.imageCount = imageIds.length
        //设置显示数量
        this.slideCount = '1/' + this.imageCount
        cornerstone.loadImage(imageIds[0]).then((image) => {
          cornerstone.displayImage(canvas, image)
          //重置
          cornerstone.reset(canvas)
          //窗宽窗位
          this.Wwwc()
          // 激活工具
          // this.Pan()
          // this.ZoomTouchPinch()
          // this.ZoomMouseWheel()
          this.currentImage = image
          //加载患者信息
          this.setPatientInfo(image)
        })

        //滑动时，执行事件
        canvas.addEventListener('cornerstoneimagerendered', this.onImageRendered)
      })
    },
    //滑动或者翻页时，执行事件
    onImageRendered(e) {
      const eventData = e.detail
      //图像序列
      this.patientInfo.number = eventData.image.data.string('x00200013')
      //放缩比
      this.patientInfo.zoom = eventData.viewport.scale.toFixed(2)

      //获取当前缩放比
      //this.currentZoom = this.patientInfo.zoom;
      //窗宽窗位
      this.patientInfo.wwc =
        parseInt(eventData.viewport.voi.windowWidth) + '/' + parseInt(eventData.viewport.voi.windowCenter)
      console.log(this.patientInfo.wwc);
        console.log(eventData.viewport.voi);
        
    },
    //设置患者信息
    setPatientInfo(image) {
      //图像序列
      this.patientInfo.number = image.data.string('x00200013')
      //放缩比
      this.patientInfo.zoom = image.data.string('x00100020')

      //第一次加载获取最开始放缩比记录当前值
      this.currentZoom = parseFloat(this.patientInfo.zoom).toFixed(2)
      //窗宽窗位
      this.patientInfo.wwc = image.data.string('x00281051')
    },
    //加载当前影像
    loadCurrnetDicom(index) {
      let canvas = this.$refs.canvas
      // 在 DOM 中将 canvas 元素注册到 cornerstone
      cornerstone.enable(canvas)
      //当前序列名称
      const imageIds = this.currentserial
      //获取当前序列
      this.currentserial = imageIds
      let currentImageId = this.currentserial[index]
      canvas.tabIndex = 0
      canvas.focus()
      cornerstone.loadAndCacheImage(currentImageId).then((image) => {
        cornerstone.displayImage(canvas, image)
      })
    },
    // 窗宽窗位
    Wwwc() {
      this.removeOption('Wwwc')
      const WwwcTool = cornerstoneTools.WwwcTool
      cornerstoneTools.addTool(WwwcTool)
      cornerstoneTools.setToolActive('Wwwc', {
        mouseButtonMask: 1,
      })
    },
    //平移
    Pan() {
      this.removeOption('Pan')
      const PanTool = cornerstoneTools.PanTool
      cornerstoneTools.addTool(PanTool)
      cornerstoneTools.setToolActive('Pan', {
        mouseButtonMask: 1,
      })
    },
    //缩放
    Zoom() {
      this.removeOption('Zoom')
      cornerstoneTools.addTool(cornerstoneTools.ZoomTool, {
        configuration: {
          invert: false,
          preventZoomOutsideImage: false,
          minScale: this.currentZoom / 10,
          maxScale: 20.0,
        },
      })

      cornerstoneTools.setToolActive('Zoom', {
        mouseButtonMask: 1,
      })
    },
    //触放缩
    ZoomTouchPinch() {
      this.removeOption('ZoomTouchPinch')
      if (isMobile()) {
        cornerstoneTools.addTool(cornerstoneTools.ZoomTouchPinchTool, {
          // Optional configuration
          configuration: {
            invert: false,
            preventZoomOutsideImage: false,
            minScale: 0.01,
            maxScale: 20.0,
          },
        })
        cornerstoneTools.setToolActive('ZoomTouchPinch', {
          mouseButtonMask: 1,
        })
      } else {
        this.Zoom()
      }
    },
    /**
     * @desc 清除上一次的操作
     */
    removeOption(currentName) {
      this.lastToolName = currentName
    },
    //鼠标滑轮放缩
    ZoomMouseWheel() {
      this.removeOption('ZoomMouseWheel')
      const ZoomMouseWheelTool = cornerstoneTools.ZoomMouseWheelTool
      cornerstoneTools.addTool(ZoomMouseWheelTool)
      cornerstoneTools.setToolActive('ZoomMouseWheel', {
        mouseButtonMask: 1,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.image_container {
  height: 100%;
  background-color: black;
  overflow-y: hidden;
}

.img_box {
  width: 100%;
  height: calc(100% - 46px);
}
.overlay {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 12px;
  color: #d8d8d8;
}
.viewport {
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: relative;
}
.viewportWrapper {
  height: calc(100% - 100px);
  color: white;
  position: relative;
}
.img_list_box {
  width: 100%;
  overflow-x: auto;
  background-color: rgb(86, 85, 85);
}
.img_list {
  width: 100%;
  height: 90px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding-right: 5px;
  .active {
    filter: blur(0) drop-shadow(6px 0 14px #ffffff);
    box-shadow: 0px 6px 14px #ffffff;
    transition: 0.2s;
  }
  & li {
    width: 80px;
    height: 80px;
    margin: 5px 0 5px 5px;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    .menu_imge {
      border-radius: 5px;
      overflow: hidden;
      pointer-events: none;
    }
    .menu_text {
      position: absolute;
      bottom: 5px;
      left: 0;
      right: 0;
      margin: auto;
      color: white;
      text-align: center;
      font-size: 12px;
    }
  }
}
.img_button {
  width: 100%;
  position: absolute;
  bottom: 5px;
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  padding: 0 5px;
  &_text {
    height: 30px;
    font-size: 12px;
    background-color: rgba(60, 100, 159, 0.7);
    padding: 5px 10px 5px 10px;
    border-radius: 4px;
    display: flex;
    margin: 0 7px 3px 0;
    img {
      width: 20px;
      height: 20px;
    }
    p {
      line-height: 20px;
      margin-right: 4px;
    }
  }
  &_Slider {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    border-radius: 5px;
    padding: 0 10px;
  }
  &_png {
    width: 30px;
    height: 30px;
    padding: 3px 5px 0;
    p {
      font-size: 12px;
      font-weight: 600;
      transform: scale(0.5);
      margin: -7px 0 0 -7px;
    }
  }
}
.loop_background {
  background-color: #0000004d;
}
</style>